import { useEffect } from 'react'
import { useMediaQuery } from 'react-responsive'
import { breakpoints } from '../../../../MediasQueries'
import MainTable from '../index'

const SelectTable = ({ products, padding, selected, setSelected, setcostTable }) => {
  const isDesktop = useMediaQuery({ minWidth: breakpoints.sm })
  const isFound = (id) => {
    if (selected.some((product) => product.id === id)) {
      return true
    }
    return false
  }
  useEffect(() => {
    let total = 0
    selected.map((prod) => (total += prod.quantidade * prod.valor_unit))
    setcostTable(total)
  }, [selected, setSelected])

  const handleSelect = (id, nome, val, unidade, quantidade) => {
    const object = { id, nome, unidade, valor_unit: val, quantidade }
    if (isFound(object.id)) {
      setSelected((products) => products.filter((product) => product.id !== object.id))
    } else {
      setSelected([...selected, object])
    }
  }

  const changingQtd = (e, id) => {
    const newProducts = selected.map((item) => {
      if (id === item.id) {
        return { ...item, quantidade: e }
      }
      return item
    })

    setSelected(newProducts)
  }

  const index = (id) => {
    const index = selected.filter((prod) => prod.id === id)
    return index[0]
  }

  return (
    <MainTable
      height={isDesktop ? '45vh' : 'auto'}
      maxHeight={'45vh'}
      padding={padding}
      products={products}
      isFound={isFound}
      index={index}
      selected={selected}
      setSelected={setSelected}
      changingQtd={changingQtd}
      handleSelect={handleSelect}
      isHomePage={false}
    />
  )
}
export default SelectTable
